import React,{ useContext} from "react";
import MyCourcesStyle from "./MyCourcesStyle.module.css";
//import material  ui
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
//impport image
import image from "../../../assets/products/google.png";
//Link
import { Link } from "react-router-dom";
//import contexts
import {AuthContext} from '../../../context/AuthContextProvider'

const MyCources = () => {
  const authContext= useContext(AuthContext)
  return (
    <>
      <h2 style={{ marginTop: "10px", textAlign: "center", color: "#f9f9f9" }}>
        دوره های من
      </h2>
{authContext.isAuth ? <div className={MyCourcesStyle.grid}>
        <div className={MyCourcesStyle.card}>
          <Card sx={{ maxWidth: 345 }}>
            <CardMedia
              component="img"
              alt="green iguana"
              height="140"
              image={image}
            />
            <CardContent>
              <h2 style={{ fontSize: "18px", textAlign: "right" }}>
                بوت استرپ
              </h2>
              <h3
                style={{
                  textAlign: "right",
                  color: "orange",
                  fontSize: "16px",
                }}
              >
                ظرفیت:
                <span
                  style={{
                    color: "#475960",
                    marginRight: "3px",
                    textDecoration: "underline",
                  }}
                >
                  19
                </span>
              </h3>

              <Typography variant="body2" color="text.secondary"></Typography>
            </CardContent>

            <div className={MyCourcesStyle.detail}>
              <Link to="/">بیشتر...</Link>
            </div>
          </Card>
        </div>
        <div className={MyCourcesStyle.card}>
          <Card sx={{ maxWidth: 345 }}>
            <CardMedia
              component="img"
              alt="green iguana"
              height="140"
              image={image}
            />
            <CardContent>
              <h2 style={{ fontSize: "18px", textAlign: "right" }}>
                بوت استرپ
              </h2>
              <h3
                style={{
                  textAlign: "right",
                  color: "orange",
                  fontSize: "16px",
                }}
              >
                ظرفیت:
                <span
                  style={{
                    color: "#475960",
                    marginRight: "3px",
                    textDecoration: "underline",
                  }}
                >
                  19
                </span>
              </h3>

              <Typography variant="body2" color="text.secondary"></Typography>
            </CardContent>

            <div className={MyCourcesStyle.detail}>
              <Link to="/">بیشتر...</Link>
            </div>
          </Card>
        </div>{" "}
        <div className={MyCourcesStyle.card}>
          <Card sx={{ maxWidth: 345 }}>
            <CardMedia
              component="img"
              alt="green iguana"
              height="140"
              image={image}
            />
            <CardContent>
              <h2 style={{ fontSize: "18px", textAlign: "right" }}>
                بوت استرپ
              </h2>
              <h3
                style={{
                  textAlign: "right",
                  color: "orange",
                  fontSize: "16px",
                }}
              >
                ظرفیت:
                <span
                  style={{
                    color: "#475960",
                    marginRight: "3px",
                    textDecoration: "underline",
                  }}
                >
                  19
                </span>
              </h3>

              <Typography variant="body2" color="text.secondary"></Typography>
            </CardContent>

            <div className={MyCourcesStyle.detail}>
              <Link to="/">بیشتر...</Link>
            </div>
          </Card>
        </div>{" "}
        <div className={MyCourcesStyle.card}>
          <Card sx={{ maxWidth: 345 }}>
            <CardMedia
              component="img"
              alt="green iguana"
              height="140"
              image={image}
            />
            <CardContent>
              <h2 style={{ fontSize: "18px", textAlign: "right" }}>
                بوت استرپ
              </h2>
              <h3
                style={{
                  textAlign: "right",
                  color: "orange",
                  fontSize: "16px",
                }}
              >
                ظرفیت:
                <span
                  style={{
                    color: "#475960",
                    marginRight: "3px",
                    textDecoration: "underline",
                  }}
                >
                  19
                </span>
              </h3>

              <Typography variant="body2" color="text.secondary"></Typography>
            </CardContent>

            <div className={MyCourcesStyle.detail}>
              <Link to="/">بیشتر...</Link>
            </div>
          </Card>
        </div>
      </div>: <h3 style={{marginTop:"100px"}}><Link style={{ fontSize:"22px"}} to='/Login'>لطفا وارد حسابتان شوید</Link></h3>}
      
    </>
  );
};

export default MyCources;
